var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{attrs:{"columns":_vm.columns,"data":_vm.resources,"size":"small","highlight-row":"","stripe":"","max-height":"700"},scopedSlots:_vm._u([{key:"barcode",fn:function(ref){
var row = ref.row;
return [_c('span',[_vm._v("\n        "+_vm._s(row.product ? row.product.barcode : 'N/A')+"\n      ")])]}},{key:"product",fn:function(ref){
var row = ref.row;
return [_c('span',[_vm._v("\n        "+_vm._s(row.product ? row.product.product_name_en : 'N/A')+"\n      ")])]}},{key:"uom",fn:function(ref){
var row = ref.row;
return [_c('span',[_vm._v("\n        "+_vm._s(row.unite_of_measure ? row.unite_of_measure.uom_name_en : 'N/A')+"\n      ")])]}},{key:"unit_price",fn:function(ref){
var row = ref.row;
return [_c('ts-display-currency',{attrs:{"amount":row.unit_price,"currency_id":row.currency_id}})]}},{key:"total",fn:function(ref){
var row = ref.row;
return [_c('ts-display-currency',{attrs:{"amount":row.total,"currency_id":row.currency_id}})]}},{key:"max_reorder",fn:function(ref){
var row = ref.row;
return [_vm._v("\n      "+_vm._s(row.product.maximum_reorder_allow
          ? row.product.maximum_reorder_allow
          : 0)+"\n    ")]}},{key:"allow_order",fn:function(ref){
          var row = ref.row;
return [(
        row.quantity_order >
        (row.product.maximum_reorder_allow
          ? row.product.maximum_reorder_allow
          : 0)
      )?_c('span',{staticClass:"badge badge-success"},[_vm._v("Yes")]):_c('span',{staticClass:"badge badge-danger"},[_vm._v("No")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }